// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"6caa12e5","230":"1fdfb4ce","309":"e365daed","409":"d53c2bd3"}[chunkId] + ".chunk.css";
};